import React from 'react'

// icon-sli icon-question

const Icon = ({ className, family, icon, tooltipText, children }) => {
  const f = (family === 'sli') ? 'icon-sli' : 'fa'
  const i = family === 'sli' ? `icon-${icon}` : `fa-${icon}`
  const compClassName = ['icon', className, f, i].join(' ')

  return (
    <i className={compClassName} data-tip={tooltipText}>{children}</i>
  )
}

export default Icon
